import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import Modal from "react-modal";
import { toast } from "react-toastify";
import CmnFilters from "../lead-management/common/CmnFilters";
import {
  fetchODMAllData,
  fetchUnassignedLeadsData,
  fetchUntrackedWatiLeadsData,
} from "../../redux/reducers/apiSlice";
import ModalHeadAndClose from "../payouts-wtf/common/ModalHeadAndClose";
import UTMParams from "../lead-management/raw-leads/UTMParams";
import AddLeadForm from "../lead-management/AddLeadForm";
import LeadFollowupV1 from "../lead-management/followup/LeadFollowupV1";
import { getReplace1 } from "../common-data/Conversions";
import { added_not_added_to_lead_boolean } from "../common-data/DropdowData";
import ODMStats from "./ODMStats";
import {
  fetchODMStatsData,
  fetchRecurringSubscriptionsData,
  fetchRecurringSubscriptionStatsData,
} from "../../redux/plans-reducers/plansSlice";
import SelectExportables from "../common-components/SelectExportables";
import {
  exportableODMTableData,
  exportableUnmappedKeywordsData,
  exportableWatiLeadsData,
} from "../pt-trials/common/SharedDatas";
import { fetchExportApiData } from "../../redux/reducers/commonApiSlice";
import ODMPCListings from "./ODMPCListings";
import CommonStructured from "../common-components/CommonStructured";
import GymwiseODM from "./GymwiseODM";
import "../../styles/odm/odm.css";
import "../../styles/odm/odm-wati-tabs.css";
import ModalCloseStart from "../payouts-wtf/common/ModalCloseStart";
import ODMWatiStats from "./odm_and-wati/ODMWatiStats";
import {
  fetchGymKeywordStatsData,
  fetchReferralStatData,
} from "../../redux/prospect-reducers/prospectSlice";
import WatiLeadListings from "./odm_and-wati/WatiLeadListings";
import WatiKeywordCount from "./odm_and-wati/WatiKeywordCount";
import RecurringSubsListings from "../recurring-subscriptions/RecurringSubsListings";
import RecurringSubsStats from "../recurring-subscriptions/RecurringSubsStats";
import ViewDetails from "./odm-details/ViewDetails";
import CommonBroadForm from "../common-components/broadcast-template/CommonBroadForm";
import WalkinsLead from "../lead-management/walkins-management/WalkinsLead";
import { isBroadcastCreateAllowedEmail } from "../common-data/Accessibles";
// import { isDev } from "../common-data/Commons";
import ReferralStructure from "../refferals/ReferralStructure";
import LeadJourney from "../lead-management/lms-v2/lead-journey/LeadJourney";
import ClickToCall from "../lead-management/lms-v2/lms-payment-links/ClickToCall";
import MapGymForm from "./MapGymForm";
import WTF360ODMListings from "../wtf-360/wtf-360-odm/WTF360ODMListings";

const ODMTabs = ({ userInfoData, isCustom, isFromLMS }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { exportData, exportLoading } = useSelector((state) => state.common);
  const { unassignedLeadsLoading } = useSelector((state) => state.api);
  const {
    oneDayStatsLoading,
    odmAllLoading,
    gymWiseODMLoading,
    recurringSubscriptionLoading,
    recurringSubscriptionStatsLoading,
  } = useSelector((state) => state.plans);

  const isBroadcastCreateAllowed = isBroadcastCreateAllowedEmail(
    userInfoData?.email
  );

  const isAdmin = userInfoData?.account_type === "admin";
  const isGym = userInfoData?.account_type === "gym";
  const isMarketing = userInfoData?.account_type === "marketing";
  const isClusterManager = userInfoData?.account_type === "cluster_manager";

  const isManagerRole = [
    "cluster_manager",
    "fitness_manager",
    "sales_manager",
    "club_manager",
  ].includes(userInfoData?.account_type);

  const TAB_CONFIG = [
    { id: 0, label: "ODM & Wati Lead Stats", alwaysVisible: true },
    { id: 1, label: "ODM", alwaysVisible: true },
    { id: 2, label: "ODM PT", alwaysVisible: true },
    { id: 3, label: "Wati Leads", alwaysVisible: true },
    {
      id: 4,
      label: "Recurring Subscription",
      alwaysVisible: false,
      condition: () => isAdmin || isClusterManager,
    },
    { id: 5, label: "Walkins", alwaysVisible: true },
    {
      id: 6,
      label: "Referrals",
      alwaysVisible: false,
      condition: () => isAdmin,
    },
    {
      id: 7,
      label: "WTF 360",
      alwaysVisible: false,
      condition: () => isAdmin,
    },
  ];

  const getVisibleTabs = () => {
    return TAB_CONFIG.filter(
      (tab) => tab.alwaysVisible || (tab.condition && tab.condition())
    );
  };

  const getLogicalTabIndex = (visualIndex) => {
    const visibleTabs = getVisibleTabs();
    return visibleTabs[visualIndex]?.id ?? 0;
  };

  const getVisualTabIndex = (logicalIndex) => {
    const visibleTabs = getVisibleTabs();
    const visualIndex = visibleTabs.findIndex((tab) => tab.id === logicalIndex);
    return visualIndex >= 0 ? visualIndex : 0;
  };

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniAllFilter = {
    selectedGym:
      !isAdmin && !isMarketing && !isManagerRole
        ? {
            label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
            value:
              userInfoData?.gym_id ||
              userInfoData?.user_id ||
              userInfoData?.uid ||
              "",
          }
        : "",
    selectedGyms: [],
    isActive: "",
    selAddNotAddToLead: isFromLMS ? added_not_added_to_lead_boolean[1] : "",
    selectedODMStatus: "",
    selectedLMSSorting: "",
    selectedDateAddedSorting: "",
    selectedGender: "",
    selAutomationKeyword: "",
    selLeadStatus: "",

    selUTMSource: "",
    selUTMMedium: "",
    selUTMContent: "",
    selUTMTerm: "",
    selUTMCampaign: "",

    selAssignedLeadDay: "",
    selAssignedLeadHour: "",
    selAssignedLeadMinute: "",
    selAssignLeadFollowupDay: "",
    selAssignLeadFollowupHour: "",
    selAssignLeadFolloupMinute: "",
    selLeadFrom: "",
    selectedLandingPageKeyword: "",

    leadAddDateFrom: "",
    leadAddDateTo: "",
    leadConvertedDateFrom: "",
    leadConvertedDateTo: "",

    searchString: "",

    selVisitScheduled: "",
    selVisitDone: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    gym_id: allFilters.selectedGym?.value || "",
    added_to_lead: allFilters.selAddNotAddToLead?.value || "",
    plan_status: allFilters.isActive?.value || "",
    is_payment_done: allFilters.selectedODMStatus?.value || "",

    not_added_lms_sort: allFilters.selectedLMSSorting || "",
    date_added_sort: allFilters.selectedDateAddedSorting || "",
    training_gym_data: 0,
    gender: allFilters.selectedGender?.value || "",
    keyword_name: allFilters.selAutomationKeyword?.label || "",
    lead_status: allFilters.selLeadStatus?.value || "",
    lead_from: allFilters.selLeadFrom?.value || "",
    keyword: allFilters.selectedLandingPageKeyword?.value || "",

    utm_source: allFilters.selUTMSource?.value || "",
    utm_medium: allFilters.selUTMMedium?.value || "",
    utm_content: allFilters.selUTMContent?.value || "",
    utm_term: allFilters.selUTMTerm?.value || "",
    utm_campaign: allFilters.selUTMCampaign?.value || "",

    start_date: allFilters.leadAddDateFrom || "",
    end_date: allFilters.leadAddDateTo || "",
    convert_start_date: allFilters.leadConvertedDateFrom || "",
    convert_end_date: allFilters.leadConvertedDateTo || "",

    visit_scheduled: allFilters.selVisitScheduled?.value || "",
    visit_done: allFilters.selVisitDone?.value || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);
  const iniModvalues = {
    isModOpen: false,
    rowData: "",
    modName: "",
    from: "",
  };
  const [modValues, setModValues] = useState(iniModvalues);
  const [selectedTab, setSelectedTab] = useState(0);
  const [currentTab, setCurrentTab] = useState("one_day_membership");
  const [selectedTabWati, setSelectedTabWati] = useState(0);
  const [csvData, setCsvData] = useState();
  const [isFilterSegmentShown, setIsFilterSegmentShown] = useState(true);

  const logicalSelectedTab = getLogicalTabIndex(selectedTab);

  const isBroadcastMode = modValues.modName === "broadcast_data";

  function closeModal() {
    setModValues(iniModvalues);
    setCsvData();
    setIsFilterSegmentShown(true);
  }

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
  };

  const onClickSearch = () => {
    setIsPage(0);

    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  const handleTabSelectPrimary = (visualIndex) => {
    setIsPage(0);
    setSelectedTab(visualIndex);
  };

  const navigateToLogicalTab = (logicalIndex) => {
    const visualIndex = getVisualTabIndex(logicalIndex);
    handleTabSelectPrimary(visualIndex);
  };

  const handleTabSelect = (index) => {
    setIsPage(0);
    setFilters((prevs) => ({
      ...prevs,
      training_gym_data: index === 2 ? 1 : 0,
    }));
    setCurrentTab(
      index === 1
        ? "odm_gymwise"
        : index === 2
        ? "one_day_membership_testing"
        : "one_day_membership"
    );
    setIsFilterSegmentShown(true);
  };

  const handleBack = (e) => {
    e.preventDefault();

    navigate("/open-access/all-pages", {
      state: { userInfo: userInfoData, decryptedText: userInfoData },
    });
  };

  function getODMStats(filters) {
    const { page, limit, keyword_name, lead_status, search, ...rest } = filters;

    dispatch(
      fetchODMStatsData({
        filters: rest,
        token: userInfoData?.token,
      })
    );
  }

  function getRecurringSubscriptionStats(filters) {
    const {
      page,
      limit,
      convert_start_date,
      convert_end_date,
      keyword_name,
      lead_status,
      not_added_lms_sort,
      date_added_sort,
      training_gym_data,
      gender,
      search,
      visit_scheduled,
      visit_done,
      ...rest
    } = filters;

    dispatch(
      fetchRecurringSubscriptionStatsData({
        filters: rest,
        token: userInfoData?.token,
      })
    );
  }

  function getGymKeywordStats(filters) {
    const {
      page,
      limit,
      training_gym_data,
      is_payment_done,
      plan_status,
      not_added_lms_sort,
      date_added_sort,
      gender,
      lead_from,
      search,
      keyword,
      visit_scheduled,
      visit_done,
      ...rest
    } = filters;

    dispatch(
      fetchGymKeywordStatsData({
        filters: { ...rest, auto_gym_map: 1 },
        token: userInfoData?.token,
      })
    );
  }

  function getRefferalStatData(filters) {
    const {
      page,
      limit,
      training_gym_data,
      convert_start_date,
      convert_end_date,
      keyword_name,
      lead_status,
      not_added_lms_sort,
      date_added_sort,
      gender,
      search,
      start_date,
      end_date,
      lead_from,
      keyword,
      visit_scheduled,
      visit_done,
      ...rest
    } = filters;

    dispatch(
      fetchReferralStatData({
        filters: {
          ...rest,
          ...(start_date && { date_from: start_date }),
          ...(end_date && { date_to: end_date }),
        },
        token: userInfoData?.token,
      })
    );
  }

  function getAllODM(filters) {
    const { keyword_name, lead_status, ...rest } = filters;

    dispatch(
      fetchODMAllData({
        filters: rest,
        token: userInfoData?.token,
      })
    );
  }

  function getWatiLeads(filters) {
    const {
      training_gym_data,
      is_payment_done,
      plan_status,
      not_added_lms_sort,
      date_added_sort,
      gender,
      lead_from,
      keyword,
      visit_scheduled,
      visit_done,
      ...rest
    } = filters;

    dispatch(
      fetchUnassignedLeadsData({
        filters: { ...rest, auto_gym_map: 1 },
        token: userInfoData?.token,
      })
    );
  }

  function getWatiUnmapped(filters) {
    const {
      training_gym_data,
      is_payment_done,
      plan_status,
      not_added_lms_sort,
      date_added_sort,
      gender,
      lead_from,
      keyword,
      visit_scheduled,
      visit_done,
      ...rest
    } = filters;

    dispatch(
      fetchUntrackedWatiLeadsData({
        filters: { ...rest, auto_gym_map: 1 },
        token: userInfoData?.token,
      })
    );
  }

  function getSubscriptions(filters) {
    const {
      convert_start_date,
      convert_end_date,
      keyword_name,
      lead_status,
      not_added_lms_sort,
      date_added_sort,
      training_gym_data,
      gender,
      visit_scheduled,
      visit_done,
      ...rest
    } = filters;

    dispatch(
      fetchRecurringSubscriptionsData({
        filters: rest,
        token: userInfoData?.token,
      })
    );
  }

  function getExportedData(filters) {
    const {
      training_gym_data,
      is_payment_done,
      plan_status,
      not_added_lms_sort,
      date_added_sort,
      gender,
      lead_from,
      keyword,
      page,
      limit,
      visit_scheduled,
      visit_done,
      ...rest
    } = filters;

    dispatch(
      fetchExportApiData({
        method: "GET",
        endpoint:
          modValues.from === "unmapped-keywords" ||
          modValues.from === "wati-leads"
            ? "/leads/unassigned"
            : "/subscription/one_day_membership_lead/all",
        // endpoint:
        //   currentTab === "one_day_membership"
        //     ? export_one_day
        //     : export_pending_one_day,
        payload: {
          filters:
            modValues.from === "unmapped-keywords" ||
            modValues.from === "wati-leads"
              ? { ...rest, auto_gym_map: 1, is_export: 1 }
              : filters,
        },
        token: userInfoData?.token,
      })
    );
  }

  const onClickExport = (filters) => {
    if (filters.is_export) {
      getExportedData(filters);
    } else {
      toast.error("IS Export Not Found!");
    }
  };

  function loadDataForTab(logicalTabIndex) {
    switch (logicalTabIndex) {
      case 0:
        getODMStats(filters);
        getGymKeywordStats(filters);
        getRefferalStatData(filters);
        getRecurringSubscriptionStats(filters);
        // getAllODM(filters);
        // getWatiLeads(filters);
        // getSubscriptions(filters);
        break;

      case 1: // ODM Tab
        getODMStats(filters);
        getAllODM(filters);
        break;

      case 2: // ODM PT Tab
        getODMStats({ ...filters, is_pt: 1 });
        getAllODM({ ...filters, is_pt: 1 });
        break;

      case 3: // Wati Leads Tab
        if (selectedTabWati === 0) {
          getGymKeywordStats(filters);
          getWatiLeads(filters);
        } else {
          getWatiUnmapped(filters);
        }
        break;

      case 4: // Recurring Subscription Tab
        getRecurringSubscriptionStats(filters);
        getSubscriptions(filters);
        break;

      case 5: // Walkins Tab - No specific API calls needed
        // WalkinsLead component handles its own data
        break;

      case 6: // Referrals Tab
        // getRefferalStatData(filters);
        break;

      case 7: // WTF 360 Tab - handled internally by WTF360ODMListings
        break;

      default:
        getODMStats(filters);
        getGymKeywordStats(filters);
        getRefferalStatData(filters);
        getRecurringSubscriptionStats(filters);
        break;
    }
  }

  function getCombineReload() {
    loadDataForTab(logicalSelectedTab);
  }

  useEffect(() => {
    loadDataForTab(logicalSelectedTab);
  }, [filters, logicalSelectedTab, selectedTabWati]);

  useEffect(() => {
    setAllFilters((prev) => {
      if (!prev.selectedGym) return prev;

      const filtered = prev.selectedGyms.filter(
        (gym) => gym?.value !== prev.selectedGym?.value
      );

      return {
        ...prev,
        selectedGyms: [prev.selectedGym, ...filtered],
      };
    });
  }, [allFilters.selectedGym]);

  useEffect(() => {
    const extractGyms = (arr) => {
      let gyms = [];

      arr?.length > 0 &&
        arr.forEach((item) => {
          const itemValue = item.value;
          gyms.push(itemValue);
        });

      return {
        gyms: gyms.join(", "),
      };
    };

    const shouldUseMultipleGyms = isBroadcastMode;
    const { gyms } = shouldUseMultipleGyms
      ? extractGyms(allFilters.selectedGyms)
      : { gyms: "" };

    const gymId = shouldUseMultipleGyms
      ? gyms || allFilters.selectedGym?.value || ""
      : allFilters.selectedGym?.value || "";

    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit,
      gym_id: gymId,
      plan_status: allFilters.isActive?.value || "",
      added_to_lead: allFilters.selAddNotAddToLead?.value || "",
      is_payment_done: allFilters.selectedODMStatus?.value || "",
      not_added_lms_sort: allFilters.selectedLMSSorting || "",
      date_added_sort: allFilters.selectedDateAddedSorting || "",
      gender: allFilters.selectedGender?.value || "",
      keyword_name: allFilters.selAutomationKeyword?.label || "",
      lead_status: allFilters.selLeadStatus?.value || "",
      lead_from: allFilters.selLeadFrom?.value || "",
      keyword: allFilters.selectedLandingPageKeyword?.value || "",

      utm_source: allFilters.selUTMSource?.value || "",
      utm_medium: allFilters.selUTMMedium?.value || "",
      utm_content: allFilters.selUTMContent?.value || "",
      utm_term: allFilters.selUTMTerm?.value || "",
      utm_campaign: allFilters.selUTMCampaign?.value || "",

      start_date: allFilters.leadAddDateFrom || "",
      end_date: allFilters.leadAddDateTo || "",
      convert_start_date: allFilters.leadConvertedDateFrom || "",
      convert_end_date: allFilters.leadConvertedDateTo || "",

      visit_scheduled: allFilters.selVisitScheduled?.value || "",
      visit_done: allFilters.selVisitDone?.value || "",
    }));
  }, [
    isPage,
    pageLimit,
    allFilters.selectedGym,
    allFilters.selectedGyms,
    allFilters.isActive,
    allFilters.selAddNotAddToLead,
    allFilters.selUTMSource,
    allFilters.selUTMMedium,
    allFilters.selUTMContent,
    allFilters.selUTMTerm,
    allFilters.selUTMCampaign,
    allFilters.leadAddDateFrom,
    allFilters.leadAddDateTo,
    allFilters.leadConvertedDateFrom,
    allFilters.leadConvertedDateTo,
    allFilters.selectedODMStatus,
    allFilters.selectedLMSSorting,
    allFilters.selectedDateAddedSorting,
    allFilters.selectedGender,
    allFilters.selAutomationKeyword,
    allFilters.selLeadStatus,
    isBroadcastMode,
    allFilters.selLeadFrom,
    allFilters.selectedLandingPageKeyword,
    allFilters.selVisitScheduled,
    allFilters.selVisitDone,
  ]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  useEffect(() => {
    if (exportData) {
      setCsvData(exportData);
    }
  }, [exportData]);

  return (
    <>
      <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={closeModal}
        contentLabel="Detail Modal"
        ariaHideApp={false}
      >
        <div
          className={`createNewCTOModalContainer ${
            modValues.modName === "assign" ? "adjustable-modal" : ""
          } ${
            modValues.modName === "utm_parameters" ||
            modValues.modName === "view_details"
              ? "mod-width-50p"
              : modValues.modName === "broadcast_data"
              ? "mod-height-95vh broadcast-modal"
              : modValues.modName === "add-to-lead"
              ? "p-0 mod-width-50p mod-height-95vh"
              : modValues.modName === "view-lead-journey"
              ? "mod-height-95vh mod-width-70p"
              : modValues.modName === "click-to-call"
              ? "mod-height-95vh mod-width-70p p-0 m-0 bg-white"
              : modValues.modName === "map-gym"
              ? "mod-width-50p"
              : ""
          }  ${modValues.modName === "view_details" ? "mod-height-95vh" : ""}`}
        >
          {modValues.modName === "click-to-call" ? null : modValues.modName ===
            "add-to-lead" ? null : modValues.modName === "follow-up" ? (
            <ModalCloseStart
              title={`${getReplace1(modValues.modName)}`}
              onClose={() => {
                closeModal();
              }}
            />
          ) : (
            <ModalHeadAndClose
              title={`${
                modValues.modName === "broadcast_data"
                  ? "New Broadcast Campaign"
                  : modValues.modName === "view_details"
                  ? `${getReplace1(modValues.from)} Lead - ${getReplace1(
                      modValues.rowData?.name || ""
                    )}`
                  : modValues.modName === "view-lead-journey"
                  ? `Lead Details - ${
                      modValues.rowData?.user_name ||
                      modValues.rowData?.name ||
                      ""
                    }`
                  : modValues.modName === "map-gym"
                  ? "Map Gym"
                  : getReplace1(modValues.modName)
              }`}
              onClose={closeModal}
            />
          )}

          {modValues.modName === "utm_parameters" ? (
            <UTMParams rowData={modValues.rowData} />
          ) : modValues.modName === "add-to-lead" ? (
            <AddLeadForm
              userInfoData={userInfoData}
              closeModal={closeModal}
              callFunction={getCombineReload}
              rowData={modValues.rowData}
              odmSource={
                logicalSelectedTab === 1 || logicalSelectedTab === 2
                  ? currentTab
                  : ""
              }
              isUnassignedRawLead={logicalSelectedTab === 3 ? true : false}
              clickedCard={logicalSelectedTab === 3 ? "wati" : ""}
              isODM={
                logicalSelectedTab === 1 || logicalSelectedTab === 2
                  ? true
                  : false
              }
              isODMPT={logicalSelectedTab === 2 ? true : false}
              isRecurring999={logicalSelectedTab === 4 ? true : false}
              isUntrackedWatiLead={
                logicalSelectedTab === 3 &&
                modValues.from === "untracked-wati-lead"
              }
            />
          ) : modValues.modName === "follow-up" ? (
            <LeadFollowupV1
              userInfoData={userInfoData}
              rowData={modValues.rowData}
              closeFollowupModal={closeModal}
              isODM={
                logicalSelectedTab === 1 || logicalSelectedTab === 2
                  ? true
                  : false
              }
              isAllLeadDetails={true}
              pageName={
                logicalSelectedTab === 1
                  ? "odm"
                  : logicalSelectedTab === 2
                  ? "odm-pt"
                  : logicalSelectedTab === 3
                  ? "wati"
                  : logicalSelectedTab === 4
                  ? "recurring-999"
                  : ""
              }
              prevFilters={(({ limit, page, added_to_lead, ...rest }) => rest)(
                filters
              )}
            />
          ) : modValues.modName === "export_data" ? (
            <SelectExportables
              name="odm"
              exportableData={
                modValues.from === "unmapped-keywords"
                  ? exportableUnmappedKeywordsData
                  : modValues.from === "wati-leads"
                  ? exportableWatiLeadsData
                  : exportableODMTableData
              }
              filters={filters}
              callFunction={onClickExport}
              isLoadingCSV={exportLoading}
              csvData={csvData}
              setCsvData={setCsvData}
            />
          ) : modValues.modName === "lead-count" ? (
            <WatiKeywordCount
              userInfoData={userInfoData}
              rowData={modValues.rowData}
            />
          ) : modValues.modName === "view_details" ? (
            <ViewDetails
              rowData={modValues.rowData}
              from={modValues.from}
              userInfoData={userInfoData}
            />
          ) : modValues.modName === "view-lead-journey" ? (
            <LeadJourney
              userInfoData={userInfoData}
              rowData={modValues.rowData}
            />
          ) : modValues.modName === "click-to-call" ? (
            <ClickToCall
              userInfoData={userInfoData}
              closeModal={closeModal}
              rowData={modValues.rowData}
            />
          ) : modValues.modName === "map-gym" ? (
            <MapGymForm
              userInfoData={userInfoData}
              closeModal={closeModal}
              callFunction={getCombineReload}
              rowData={modValues.rowData}
            />
          ) : modValues.modName === "broadcast_data" ? (
            <>
              {isFilterSegmentShown && (
                <CmnFilters
                  from={
                    logicalSelectedTab === 4
                      ? "recurring-999"
                      : "one-day-membership"
                  }
                  isSegment={true}
                  userInfoData={userInfoData}
                  onClickReset={onResetFilters}
                  filters={allFilters}
                  setFilters={setAllFilters}
                  clickedCard={logicalSelectedTab === 4 ? null : currentTab}
                  selectedTab={logicalSelectedTab}
                  isLoading={
                    (logicalSelectedTab === 0 &&
                      (recurringSubscriptionLoading ||
                        recurringSubscriptionStatsLoading ||
                        unassignedLeadsLoading ||
                        oneDayStatsLoading ||
                        odmAllLoading ||
                        gymWiseODMLoading)) ||
                    (logicalSelectedTab === 4 &&
                      (recurringSubscriptionLoading ||
                        recurringSubscriptionStatsLoading)) ||
                    (logicalSelectedTab === 3 && unassignedLeadsLoading) ||
                    ((logicalSelectedTab === 1 || logicalSelectedTab === 2) &&
                      (oneDayStatsLoading ||
                        odmAllLoading ||
                        gymWiseODMLoading))
                  }
                  isBroadcastModal={true}
                />
              )}

              <CommonBroadForm
                from={modValues.from}
                selectedTab={selectedTabWati === 1 ? "untracked-wati-lead" : ""}
                filters={filters}
                allFilters={allFilters}
                userInfoData={userInfoData}
                closeModal={closeModal}
                setIsFilterSegmentShown={setIsFilterSegmentShown}
              />
            </>
          ) : null}
        </div>
      </Modal>

      <CommonStructured
        pageHeading={
          "ODM || Wati Leads || Recurring Subscription || Walkin Leads"
        }
        isReload={
          logicalSelectedTab === 5 ||
          logicalSelectedTab === 6 ||
          selectedTabWati === 2 ||
          logicalSelectedTab === 7
            ? null
            : getCombineReload
        }
        onClickBackBtn={isCustom ? handleBack : null}
      />

      <div className="discount-payments-tabs bgTransParent odm-wati-container mt30">
        <Tabs selectedIndex={selectedTab} onSelect={handleTabSelectPrimary}>
          <TabList>
            {getVisibleTabs().map((tab) => (
              <Tab key={tab.id}>{tab.label}</Tab>
            ))}
          </TabList>

          {logicalSelectedTab !== 5 &&
          logicalSelectedTab !== 6 &&
          logicalSelectedTab !== 7 &&
          selectedTabWati !== 2 &&
          currentTab !== "odm_gymwise" ? (
            <CmnFilters
              from={
                logicalSelectedTab === 4
                  ? "recurring-999"
                  : "one-day-membership"
              }
              userInfoData={userInfoData}
              onClickReset={onResetFilters}
              filters={allFilters}
              setFilters={setAllFilters}
              onClickSearch={onClickSearch}
              searchFilterApplied={searchFilterApplied}
              clickedCard={
                logicalSelectedTab === 4
                  ? null
                  : logicalSelectedTab === 5
                  ? "walkins"
                  : currentTab
              }
              onClickExportBtn={
                logicalSelectedTab === 4
                  ? null
                  : logicalSelectedTab === 3 && selectedTabWati === 0
                  ? () =>
                      setModValues((prevs) => ({
                        ...prevs,
                        isModOpen: true,
                        modName: "export_data",
                        from: "wati-leads",
                      }))
                  : logicalSelectedTab === 3 && selectedTabWati === 1
                  ? () =>
                      setModValues((prevs) => ({
                        ...prevs,
                        isModOpen: true,
                        modName: "export_data",
                        from: "unmapped-keywords",
                      }))
                  : logicalSelectedTab === 1
                  ? () =>
                      setModValues((prevs) => ({
                        ...prevs,
                        isModOpen: true,
                        modName: "export_data",
                      }))
                  : null
              }
              onClickBroadcastBtn={
                isBroadcastCreateAllowed
                  ? () =>
                      setModValues((prevs) => ({
                        ...prevs,
                        isModOpen: true,
                        modName: "broadcast_data",
                        from:
                          logicalSelectedTab === 4
                            ? "recurring"
                            : logicalSelectedTab === 3
                            ? "wati"
                            : "odm",
                      }))
                  : null
              }
              isReload={getCombineReload}
              selectedTab={logicalSelectedTab}
              isLoading={
                (logicalSelectedTab === 0 &&
                  (recurringSubscriptionLoading ||
                    recurringSubscriptionStatsLoading ||
                    unassignedLeadsLoading ||
                    oneDayStatsLoading ||
                    odmAllLoading ||
                    gymWiseODMLoading)) ||
                (logicalSelectedTab === 4 &&
                  (recurringSubscriptionLoading ||
                    recurringSubscriptionStatsLoading)) ||
                (logicalSelectedTab === 3 && unassignedLeadsLoading) ||
                ((logicalSelectedTab === 1 || logicalSelectedTab === 2) &&
                  (oneDayStatsLoading || odmAllLoading || gymWiseODMLoading))
              }
            />
          ) : null}

          {getVisibleTabs().map((tab) => {
            switch (tab.id) {
              case 0:
                return (
                  <TabPanel key={tab.id} className="mt30">
                    <ODMWatiStats onNavigateToTab={navigateToLogicalTab} />
                  </TabPanel>
                );
              case 1:
                return (
                  <TabPanel key={tab.id}>
                    <div className="odm-tabs-new">
                      <Tabs onSelect={handleTabSelect}>
                        <TabList>
                          <Tab>One Day Membership (ODM)</Tab>
                          {isAdmin && (
                            <Tab>One Day Membership (ODM) Gymwise</Tab>
                          )}
                          {/* {isAdmin && <Tab>Testing Gym</Tab>} */}
                        </TabList>

                        <TabPanel>
                          <ODMStats />

                          <ODMPCListings
                            isPage={isPage}
                            setIsPage={setIsPage}
                            pageLimit={pageLimit}
                            setPageLimit={setPageLimit}
                            setModValues={setModValues}
                            allFilters={allFilters}
                            setAllFilters={setAllFilters}
                            isFromLMS={isFromLMS}
                          />
                        </TabPanel>

                        <TabPanel>
                          <GymwiseODM userInfoData={userInfoData} />
                        </TabPanel>
                      </Tabs>
                    </div>
                  </TabPanel>
                );
              case 2:
                return (
                  <TabPanel key={tab.id}>
                    <ODMStats />

                    <ODMPCListings
                      isPage={isPage}
                      setIsPage={setIsPage}
                      pageLimit={pageLimit}
                      setPageLimit={setPageLimit}
                      setModValues={setModValues}
                      allFilters={allFilters}
                      setAllFilters={setAllFilters}
                      isFromLMS={isFromLMS}
                    />
                  </TabPanel>
                );
              case 3:
                return (
                  <TabPanel key={tab.id}>
                    <WatiLeadListings
                      isPage={isPage}
                      setIsPage={setIsPage}
                      pageLimit={pageLimit}
                      setPageLimit={setPageLimit}
                      setModValues={setModValues}
                      userInfoData={userInfoData}
                      selectedTab={selectedTabWati}
                      setSelectedTab={setSelectedTabWati}
                    />
                  </TabPanel>
                );
              case 4:
                return (
                  <TabPanel key={tab.id}>
                    <RecurringSubsStats isFromODM={true} isTbData={true} />

                    <RecurringSubsListings
                      isPage={isPage}
                      setIsPage={setIsPage}
                      pageLimit={pageLimit}
                      setPageLimit={setPageLimit}
                      setModValues={setModValues}
                      isFromODM={true}
                    />
                  </TabPanel>
                );
              case 5:
                return (
                  <TabPanel key={tab.id}>
                    <WalkinsLead userInfoData={userInfoData} />
                  </TabPanel>
                );
              case 6:
                return (
                  <TabPanel key={tab.id}>
                    <ReferralStructure
                      userInfoData={userInfoData}
                      isODM={true}
                    />
                  </TabPanel>
                );
              case 7:
                return (
                  <TabPanel key={tab.id}>
                    <WTF360ODMListings
                      userInfoData={userInfoData}
                      setModValues={setModValues}
                    />
                  </TabPanel>
                );
              default:
                return null;
            }
          })}
        </Tabs>
      </div>
    </>
  );
};

export default ODMTabs;
